import {transition,animate,trigger,style, stagger ,query, sequence} from '@angular/animations'

export const routeAnimation = trigger('routeAnimation',[
    transition('* <=> *',[
        style({ position: 'relative' }),
        query(':enter', style({ opacity:0,position: 'absolute', top: 0, left: 0, width: '100%' }),{optional:true}),
        query(':leave', style({ opacity:1,position: 'absolute', top: 0, left: 0, width: '100%'  }),{optional:true}),

        sequence([
            query(':leave',[
                animate('0.25s ease-in-out',
                    style({ opacity: 0 })
                )
            ],{optional:true}),
            sequence([
                query(':enter',[
                    animate('0.25s ease-in-out',
                       style({ opacity:1 }) 
                    )
                ],{optional:true})
            ])
        ])
    ])
])